import { render, staticRenderFns } from "./ScreenIc.vue?vue&type=template&id=be187afe"
import script from "./ScreenIc.vue?vue&type=script&lang=js"
export * from "./ScreenIc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports